import { AsyncPipe, UpperCasePipe } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
  OnyxAddressComponent,
  OnyxDatePipe,
  OnyxNamePipe,
  OnyxPhonePipe,
} from '@onyx/angular';
import { DateTime } from 'luxon';
import { of } from 'rxjs';
import { AuthStore } from '../../../../../../../../../auth/common/stores/auth.store';
import { ContractorsService } from '../../../../../../../../management-panel/contractors/common/services/contractors.service';
import type { Order } from '../../../../../../../common/interfaces/order';

@Component({
  selector: 'app-order-pdf-template-contractors',
  imports: [
    TranslatePipe,
    UpperCasePipe,
    OnyxDatePipe,
    OnyxAddressComponent,
    OnyxNamePipe,
    OnyxPhonePipe,
    AsyncPipe,
  ],
  templateUrl: './order-pdf-template-contractors.component.html',
  styleUrl: './order-pdf-template-contractors.component.scss',
})
export class OrderPdfTemplateContractorsComponent {
  private readonly authStore = inject(AuthStore);
  private readonly contractorsService = inject(ContractorsService);

  public readonly order = input.required<Order>();

  protected readonly I18N = 'orders.pdfTemplate';

  protected business = this.authStore.business()!;
  protected today = DateTime.now().toISO();

  protected contractor$ = computed(() => {
    const contractorUuid = this.order().outsourcingData?.contractor.uuid;
    if (!contractorUuid) return of(null);

    return this.contractorsService.getContractor(contractorUuid);
  });
}
